import { Link, useSearchParams } from "react-router-dom";
import { LocalStorageService } from "../../helpers";
import { useDispatch } from "react-redux";
import * as actions from "../../actions";
import { useEffect, useState } from "react";
import ProfileService from "../../core/services/profile.service";
import { useTranslation } from "react-i18next";
import "../../i18n";

// const TAB_MENU = [
//   {
//     id: 0,
//     title: "Trang chủ",
//     link: "/",
//   },
//   {
//     id: 1,
//     title: "Dịch vụ",
//     link: "/",
//   },
//   {
//     id: 2,
//     title: "Ứng dụng",
//     link: "/",
//   },
//   {
//     id: 3,
//     title: "Quản lý",
//     link: "/",
//   },
// ];

const Header = ({ logo, center }: { logo: string; center: boolean }) => {
  // const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const accessTokenExp = LocalStorageService.getAccessToken();
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang");
  const [isInitialized, setIsInitialized] = useState(false);
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const [openModal, setOpenModal] = useState(false);
  const [showMore, setShowMore] = useState(false);
  // Khi user đổi ngôn ngữ:
  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  const handleLogout = () => {
    LocalStorageService.clearToken();
    window.location.href = "/";
  };
  const languages = [
    {
      id: 1,
      content: "vi",
      title: "VIE",
    },
    {
      id: 2,
      content: "en",
      title: "EN",
    },
  ];

  useEffect(() => {
    const storedLang = localStorage.getItem("language") || "vi";
    if (!isInitialized) {
      i18n.changeLanguage(storedLang);
      setIsInitialized(true);
    } else if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, isInitialized]);


  return (
    <div className="w-full relative z-10">
      <div
        className={`mx-auto flex items-center ${center
          ? "md:justify-center md:pt-[80px] pt-[16px]"
          : " justify-between py-4"
          } px-[16px]   sm:px-6 lg:px-[100px]`}
      >
        <div
          className={`flex gap-8 w-full ${center ? "md:justify-center" : "justify-between "
            }`}
        >
          <Link to="/" className="flex items-center gap-[12px]">
            <div
              className={`${center
                ? "md:w-[200px] w-[100px] md:h-[80px] "
                : "w-[100px] h-[40px] min-[320px]:w-[80px] min-[320px]:h-[32px]"
                }`}
            >
              <img
                src="/images/payment/ocbLogo.png"
                alt="loading icon"
                width={center ? 200 : 103}
                height={center ? 80 : 40}
              />
            </div>
            <div className="flex gap-2 items-center">
              <div
                className={`${center
                  ? "md:w-[24px] md:h-[24px] w-[8px] h-[8px]"
                  : "w-[8px] h-[8px]"
                  }`}
              >
                <img
                  src="/images/payment/x.png"
                  alt="loading icon"
                  width={center ? 24 : 8}
                  height={center ? 24 : 8}
                />
              </div>
              <div
                className={`${center
                  ? "md:w-[200px] w-[100px] md:h-[80px] "
                  : "w-[100px] h-[40px] min-[320px]:w-[80px] min-[320px]:h-[32px]"
                  }`}
              >
                <img
                  src={logo}
                  alt="Logo"
                  width={center ? 200 : 103}
                  height={center ? 80 : 40}
                />
              </div>
            </div>
          </Link>
          {/* <div className="my-1 hidden w-[2px] bg-[#F0F0F0] sm:block md:block"></div> */}
          {/* Desktop Menu */}
          {/* <div className="hidden md:flex md:items-center md:gap-8">
            <div className="hidden md:flex md:flex-row md:items-center md:gap-8">
              {TAB_MENU.map((item) => (
                <Link
                  key={`tab_menu_item_${item.id}`}
                  to={item.link}
                  className="text-base font-medium leading-5 text-text-black"
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </div> */}
          {/* <div className="flex items-center gap-2">
            {accessTokenExp && (
              <button
                className="px-3 py-[6px] rounded-[8px] border-[#d6d6d6] border-[solid] border-[1px]"
                onClick={handleLogout}
              >
                {t("log_out")}
              </button>
            )}
          </div> */}
        </div>
        <div className="md:hidden flex gap-[8px] items-center">
          <div
            onClick={() => setOpenModal(!openModal)}
            style={{ userSelect: "none", WebkitUserSelect: "none" }}
            className="px-4 py-[4px] border-[1px] border-solid rounded-[8px] border-[#d6d6d6] text-[12px] font-semibold relative flex items-center gap-[6px] cursor-pointer"
          >
            {language === "en" ? "EN" : "VIE"}
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBtGqMjA1BOSa2k_BNNRyjnXjfYth0D86xhQ&s"
              alt="dropdown icon"
              width={12}
              height={12}
            />
            {openModal && (
              <div
                onClick={(e) => e.stopPropagation()}
                className="absolute top-[30px] w-full left-0 border-[#d6d6d6] border-[solid] border-[1px] flex flex-col rounded-[8px]"
              >
                {languages.map((item: any) => {
                  return (
                    <button
                      onClick={() => {
                        changeLanguage(item.content);
                        setOpenModal(false);
                      }}
                      className={`px-4 py-[4px] hover:bg-[#eeeeee] ${language == item.content && "bg-[#eeeeee]"
                        }`}
                      key={item.id}
                    >
                      {item.title}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
          {accessTokenExp && (
            <button
              onClick={() => setShowMore(!showMore)}
              className="relative w-[24px] h-[24px] flex justify-center items-center"
            >
              <img src="/images/payment/more.svg" alt="more icon" />
              {showMore && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="absolute bg-[#fff] shadow-xl px-[8px] py-[3px] rounded-[8px] w-[110px] bottom-[-35px] left-[-100px] z-[2] border-[1px] border-solid border-[#aaa9a9]"
                >
                  <button
                    className="px-[8px] py-[3px] rounded-[8px]"
                    onClick={handleLogout}
                  >
                    {t("log_out")}
                  </button>
                </div>
              )}
            </button>
          )}
        </div>

        {/* <div className="hidden md:block">
          <button className="h-fit w-fit rounded-lg bg-primary px-6 py-3 text-base font-medium leading-[19.36px] text-white">
            Đăng nhập
          </button>
        </div> */}

        {/* Mobile Menu Button */}
        {/* <div className="md:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-text-black"
          >
            <Menu size={24} />
          </button>
        </div> */}
      </div>
      <div className="fixed md:top-[25px] top-[20px] right-4 md:flex md:gap-[16px] gap-[8px] items-center hidden">
        {accessTokenExp && (
          <button
            className="px-3 py-[6px] rounded-[8px] border-[#d6d6d6] border-[solid] border-[1px]"
            onClick={handleLogout}
          >
            {t("log_out")}
          </button>
        )}
        <div
          onClick={() => setOpenModal(!openModal)}
          style={{ userSelect: "none", WebkitUserSelect: "none" }}
          className="px-4 py-[4px] border-[1px] border-solid rounded-[8px] border-[#d6d6d6] text-[12px] font-semibold relative flex items-center gap-[6px] cursor-pointer"
        >
          {language === "vi" ? "VIE" : "EN"}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBtGqMjA1BOSa2k_BNNRyjnXjfYth0D86xhQ&s"
            alt="dropdown icon"
            width={12}
            height={12}
          />
          {openModal && (
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute top-[30px] w-full left-0 border-[#d6d6d6] border-[solid] border-[1px] flex flex-col rounded-[8px]"
            >
              {languages.map((item: any) => {
                return (
                  <button
                    onClick={() => {
                      changeLanguage(item.content);
                      setOpenModal(false);
                    }}
                    className={`px-4 py-[4px] hover:bg-[#eeeeee] ${language == item.content && "bg-[#eeeeee]"
                      }`}
                    key={item.id}
                  >
                    {item.title}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
      {/* Mobile Menu */}
      {/* {isMenuOpen && (
        <div className="md:hidden">
          <div className="space-y-1 px-2 pb-3 pt-2">
            {TAB_MENU.map((item) => (
              <Link
                key={`mobile_menu_item_${item.id}`}
                to={item.link}
                className="block rounded-md px-3 py-2 text-base font-medium text-text-black hover:bg-gray-50"
              >
                {item.title}
              </Link>
            ))}
          </div>
          <div className="px-2 pb-3">
            <button className="w-full rounded-lg bg-primary px-6 py-3 text-base font-medium leading-[19.36px] text-white">
              Đăng nhập
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Header;
